export { ResizeObserver } from '../ResizeObserver';
export { ResizeObserverEntry } from '../ResizeObserverEntry';
export { ResizeObserverSize } from '../ResizeObserverSize';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@juggle/resize-observer/lib/exports/resize-observer.js
// module id = 704
// module chunks = 1